import React from "react";
import Modal from "react-modal";
import utilityFunctions from "@store/utilityFunctions";

export function ServiceTypeModal({
  isOpen,
  typeService,
  statusTicketType,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Set as Out of Warranty"
      className="confirm-modal confirm-modal-ticket"
    >
      <form onSubmit={onConfirm}>
        <div className="card">
          <div className="card-header">Ticket service type</div>
          <div className="card-body">
            <div className="mb-3">
              Change service type to{" "}
              {utilityFunctions.toTitleCase(
                typeService?.replaceAll("_", " "),
              ) ||
                utilityFunctions.toTitleCase(
                  statusTicketType?.replaceAll("_", " "),
                )}
              ?{" "}
            </div>
            <button
              data-testid="confirm-service-type"
              type="button"
              className="btn btn-outline-primary mr-3"
              onClick={onConfirm}
            >
              Confirm
            </button>
            <button
              data-testid="cancel-service-type"
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
